import { autoGeneratedReducer } from '@hh.ru/redux-create-reducer';

import { ResumeCardData } from 'src/models/resumeCard';

interface GiftedResumes {
    resumes: ResumeCardData[];
}

export default autoGeneratedReducer<GiftedResumes>({ resumes: [] });
